import { createSlice } from "@reduxjs/toolkit";
import {
  getAllPlans,
  myCurrentSubscription,
  getBillingHistory,
  startFreeTrial,
  buySubscription,
  upgradePlan,
  calculateUpgradePlanSubscription

} from "store/actions/subscriptionSlice";

const initialState = {
  isLoading: false,
  mySubscriptionDetails: [],
  loading: false,
  perPage: 10,
  totalCount: null,
  paymentMethod: null,
  totalPages: null,
  currentPage: null,
  allPlans: [],
  transactions: [],
  subscriptionCalculationResponse: {},
  gettingDetails: false,
};

const subscriptionSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    setSortedTransactions: (state, action) => {
      state.transactions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPlans.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPlans.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } = action.payload || {};
          state.allPlans = data;

        }
      })
      .addCase(getAllPlans.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(startFreeTrial.pending, (state) => {
        state.loading = true;
      })
      .addCase(startFreeTrial.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } = action.payload || {};
          // state.allPlans = data;

        }
      })
      .addCase(startFreeTrial.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(myCurrentSubscription.pending, (state) => {
        state.loading = true;
      })
      .addCase(myCurrentSubscription.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } = action.payload || {};
          state.mySubscriptionDetails = data;
          // state.allPlans = data;

        }
      })
      .addCase(myCurrentSubscription.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(getBillingHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBillingHistory.fulfilled, (state, action) => {

        state.loading = false;
        const { success, data, totalCount, totalPages, currentPage } =
          action.payload || {};
        if (success) {
          state.transactions = data || [];
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getBillingHistory.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(buySubscription.pending, (state, action) => {
        state.isLoading = true;
        const paymentMethod = action.meta.arg?.paymentDetails?.method;
        state.paymentMethod = paymentMethod || null;
      })
      .addCase(buySubscription.fulfilled, (state, action) => {
        state.isLoading = false;
        state.paymentMethod = null;
      })
      .addCase(buySubscription.rejected, (state, action) => {
        state.isLoading = false;
        state.paymentMethod = null;
      });
    builder
      .addCase(calculateUpgradePlanSubscription.pending, (state) => {
        state.isLoading = true;
        // state.subscriptionCalculationResponse = {};
      })
      .addCase(calculateUpgradePlanSubscription.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.subscriptionCalculationResponse = data || {};
        }
      })
      .addCase(calculateUpgradePlanSubscription.rejected, (state, action) => {
        state.isLoading = false;
      });
    builder
      .addCase(upgradePlan.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(upgradePlan.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(upgradePlan.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default subscriptionSlice.reducer;
export const { setSortedTransactions } = subscriptionSlice.actions;

